export function getHighlightBoundaries({
  highlightTime,
  recordingDuration,
}: {
  highlightTime: { end: number; marker: number; start: number } | null;
  recordingDuration: number;
}): {
  start: number;
  marker: number;
  end: number;
} | null {
  if (highlightTime === null) {
    return null;
  }

  return {
    end: (highlightTime.end / recordingDuration) * 100,
    marker: (highlightTime.marker / recordingDuration) * 100,
    start: (highlightTime.start / recordingDuration) * 100,
  };
}
